/* VIDEO BANNER*/
import acceptedCookiePolicy from "../onetrust/cookiePolicy";

const formResources = 'form.enable-resource';

const isNotDesktop = () => {
    return breakpoint === 'xs' || breakpoint === 'sm';
};

const playerIsReady = () => {
    $('.button.video, .button.fullVideo').addClass('is-ready');
};

/**************************************************************/
/********* Set Video panel*************************************/
/*************************************************************/

const appendIframeInHero = () => {
    const $videoPlaceholder = $('[data-placeholder="video"]');
    const $fullVideoContainer = $('.outer_fullVideo_container');
    const $button = $('.hero .button.fullVideo');

    if (isNotDesktop()) {
        /*
        * Add video has "overlay"
         */
        if (!$fullVideoContainer.find('[data-video-player]').length) {
            $videoPlaceholder.find('[data-video-player]').appendTo('.inner_fullVideo_container');
        }

        if ($fullVideoContainer.find('[data-video-player][data-rendered]').length) {
            $fullVideoContainer.removeClass('hide');

            $fullVideoContainer.velocity({
                opacity: 1
            }, {
                duration: 300,
                queue: false,
                display: 'block'
            });

            $button.velocity({
                opacity: 1
            }, {
                queue: false,
                duration: 300,
            }).removeClass('pointer-none');
        }
    } else {
        /*
        * Add video in hero
         */
        if (!$videoPlaceholder.find('[data-video-player]').length) {
            $fullVideoContainer.find('[data-video-player]').appendTo($videoPlaceholder[0]);
        }

        if ($videoPlaceholder.find('[data-video-player][data-rendered]').length) {
            $videoPlaceholder.addClass('is-visible');

            $button.velocity({
                opacity: 0
            },{
                queue: false,
                duration: 300
            }).addClass('pointer-none');
        }
    }
};

const videoBannerInitPlayer = $container => {
    $container.attr('data-rendered', 'true');
    $container.closest('.hero-video-placeholder').addClass('is-visible');
    $container.trigger('click');
};

const videoBannerInit = () => {
    const $hero = $('.hero');
    const $videoContainer = $hero.find('.hero-featured-video .video_placeholder');
    
    if (!$videoContainer.length) {
        return;
    }

    $('.hero').find(".button.fullVideo").on("click", function(e) {
        e.preventDefault();
        e.stopPropagation();

        const $container = $hero.find("[data-video-player]");

        if ($container.data('rendered')) {
            appendIframeInHero();
        } else {
            videoBannerInitPlayer($container);
        }

        if (!Cookies.get('marketo_id')) {
            acceptedCookiePolicy({
                ifFunctionalCookies: () => {
                    Cookies.set('view_video', $('[data-input="sitecore-id"]').val());
                }
            });
        }
    });

    $('.inner_fullVideo_container').find('.close').off().on('click', function(e) {
        e.preventDefault();

        if ($(formResources).length) {
            if ($('.fullVideo.hide-btn')) {
                $('.fullVideo.hide-btn').removeClass('hide-btn');
            }

            $('.outer_fullVideo_container').removeClass('is-playing');
        }

        //close the hero video panel
        $('.hero').velocity('stop').find(".outer_fullVideo_container").velocity({
            opacity: 0
        }, {
            duration: 300,
            display: 'none',
            begin: function() {
                $(this).find('[data-video-player]').appendTo('.hero-video-placeholder');
            }
        });
    });

    window.addEventListener('resize', () => {
        if (typeof debounce !== 'undefined') {
            debounce(appendIframeInHero(), 250);
        }
    });

    playerIsReady();
};


export { videoBannerInit, videoBannerInitPlayer };